import { Button, useLocalVariant } from "@draftkings/arena-web";
import * as React from "react";
export const CashOutViewConfirm = React.memo(function CashOutViewConfirm(props) {
    const { formattedCashOutAmount, purchaseId, onClick } = props;
    const variant = useLocalVariant("button", {
        $extendFromVariant: "primaryMedium",
        root: {
            marginBottom: "$s2",
            cursor: "pointer",
        }
    });
    return React.createElement(Button, { onClick: onClick, widthMode: "stretch", variant: variant, testId: `cashout-button-${purchaseId}` }, formattedCashOutAmount);
});
//# sourceMappingURL=CashOutButtonConfirm.js.map